import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { Title } from '@angular/platform-browser';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { LanguagesService } from "@easyfo/common-lib";
import { environment } from '../../../environments/environment';
import { FrontService } from '../../services/front';
import { UsersService } from '../../services/user';
import { KeyValue } from '@angular/common';

@Component({
  selector: 'app-closeday-process',
  templateUrl: './closeday-process.component.html',
  styleUrls: ['./closeday-process.component.css'],
})
export class CloseDayProcessComponent implements OnInit {
  constructor(private titleService: Title,
    private _userService: UsersService,
    private _frontService: FrontService,
    private _languagesService: LanguagesService,
    private _router: Router
  ) {
    this.titleService.setTitle("Close Day Process");
    if (!this._userService.isLogin()) {
      this._router.navigate(['/login']);
    }
    this._languagesService.setByCookies();
    this._languagesService.getText('form_login_app.form_landing_app.fail_msg', (text: string) => {
      this.landingFailMessage = text;
    })
  }

  isShowSidebarButton: boolean = document.documentElement.clientWidth < 600;

  @HostListener('window:resize', ['$event'])
  updateWidth(): void {
    const viewportWidth = document.documentElement.clientWidth;
    if (viewportWidth < 600) {
      this.isShowSidebarButton = true;
    } else {
      this.isShowSidebarButton = false;
    }
  }

  landingFailMessage: string = "";
  intervalId: any;
  stateMessages: any = {
    1: 'Repairing Data Close Day',
    10: 'Backup Data',
    20: 'Preparing Before Close Day Report',
    30: 'Close Day Statistic',
    40: 'Preparing Data Close Day',
    50: 'Preparing After Close Day Report',
    60: 'Sending Email',
		70: 'Complete Close Day'
  }

	hotelName: string = '';
	systemDate: string = '';
	closedayInProgress: boolean = false;
	closedayState: number = 0;
	closedayById: string = '';
	closedayBy: string = '';
  allowCancel: boolean = false;
  notFirstLoad: boolean = false;

  ngOnInit(): void {
    this.hotelName = this._frontService.getHotelName();
    this.requesting();
    this.intervalId = setInterval(() => {
      this.notFirstLoad = true;
      this.requesting();
    }, 10000);
  }

  requesting() {
    this._frontService.requestCloseDayCheck().then(async ({ state, userId, userName, allow }) => {
      if (state < 10 && allow) {
        this.allowCancel = true;
      } else {
        this.allowCancel = false;
      }
			if (state > 0) {
				this.closedayInProgress = true;
			} else {
				this.closedayInProgress = false;
			}
			if (this.closedayState === state) {
				return;
			}
			this.closedayById = userId;
			this.closedayBy = userName;
			this.closedayState = state;

      if (state === 0) {
        clearInterval(this.intervalId);
        this._router.navigate(['/landing']);
        return;
      }
    }).catch(() => this._router.navigate(['/landing']));
  }

  ngOnDestroy() {
    if (this.intervalId) clearInterval(this.intervalId);
  }

  cancelCloseDayClick() {
    if (!this.allowCancel) {
      return;
    }
    Swal.fire({
      position: 'center',
      icon: 'warning',
      title: 'Confirm cancel Close Day!',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: this._languagesService.getTextForTs('global.button.yes'),
      cancelButtonText: this._languagesService.getTextForTs('global.button.no'),
      customClass: environment.alert_sweet,
      buttonsStyling: false,
    }).then((confirm) => {
      if (!confirm.isConfirmed) return;
      this._frontService.cancelCloseDayClick()
        .then((status: boolean) => {
          if (status == true)
            this._router.navigate(['/landing']);
        })
    });
  }

  originalOrder = (a: KeyValue<string, string>, b: KeyValue<string, string>): number => {
		return parseInt(a.key) - parseInt(b.key);
	}

	getStepStatus(stepKey: string): 'completed' | 'current' | 'pending' {
		const key = parseInt(stepKey);
		if (this.closedayState > key) return 'completed';
		if (this.closedayState === key) return 'current';
		return 'pending';
	}

}
